export default __webpack_public_path__ + "79e85bb3d5a4e601c38299bf1ca41873.jpeg";